import { z } from 'zod';

export const emailSchema = z
  .string()
  .min(1, 'אימייל חובה')
  .email('אימייל לא תקין');

export const passwordSchema = z
  .string()
  .min(8, 'סיסמה חייבת לפחות 8 תווים עם אות וספרה')
  .regex(/[a-zA-Z]/, 'סיסמה חייבת לפחות 8 תווים עם אות וספרה')
  .regex(/[0-9]/, 'סיסמה חייבת לפחות 8 תווים עם אות וספרה');

export const loginSchema = z.object({
  email: emailSchema,
  password: z.string().min(1, 'סיסמה חובה'),
  remember: z.boolean().optional(),
});
export type LoginInput = z.infer<typeof loginSchema>;

export const signupSchema = z
  .object({
    email: emailSchema,
    password: passwordSchema,
    confirmPassword: z.string().min(1, 'אימות סיסמה חובה'),
  })
  .refine((data) => data.password === data.confirmPassword, {
    path: ['confirmPassword'],
    message: 'הסיסמאות לא תואמות',
  });
export type SignupInput = z.infer<typeof signupSchema>;

export const forgotSchema = z.object({
  email: emailSchema,
});
export type ForgotInput = z.infer<typeof forgotSchema>;

export const resetSchema = z
  .object({
    password: passwordSchema,
    confirmPassword: z.string().min(1, 'אימות סיסמה חובה'),
  })
  .refine((data) => data.password === data.confirmPassword, {
    path: ['confirmPassword'],
    message: 'הסיסמאות לא תואמות',
  });
export type ResetInput = z.infer<typeof resetSchema>;

export const otpSchema = z.object({
  code: z
    .string()
    .length(6, 'הקוד חייב 6 ספרות')
    .regex(/^\d{6}$/, 'הקוד חייב 6 ספרות'),
});
export type OtpInput = z.infer<typeof otpSchema>;
